import * as angular from 'angular';
import { ComponentDefinition } from '../../models';

class CheckboxController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;

    static $inject = [];
}

export const wtCheckbox: ComponentDefinition = {
    componentId: 'wtCheckbox',
    controller: CheckboxController,
    template: require('./checkbox.component.html'),
    controllerAs: 'vm',
    bindings: {
        model: '=',
        disabled: '<?',
        name: '@?'
    }
};
